var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 30C7.65 30 7.125 29.775 6.675 29.325C6.225 28.875 6 28.35 6 27.75V22.3875H8.25V27.75H27.75V22.3875H30V27.75C30 28.35 29.775 28.875 29.325 29.325C28.875 29.775 28.35 30 27.75 30H8.25ZM16.875 24.2625V10.35L12.375 14.85L10.7625 13.2375L18 6L25.2375 13.2375L23.625 14.85L19.125 10.35V24.2625H16.875Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.716ca169c9867eb2cb68a6d1271b5ea0.svg";
export { ForwardRef as ReactComponent };